import { render, staticRenderFns } from "./PrivewEmail.vue?vue&type=template&id=6d64b50d&scoped=true"
import script from "./PrivewEmail.vue?vue&type=script&lang=js"
export * from "./PrivewEmail.vue?vue&type=script&lang=js"
import style0 from "./PrivewEmail.vue?vue&type=style&index=0&id=6d64b50d&prod&scoped=true&lang=scss"
import style1 from "./PrivewEmail.vue?vue&type=style&index=1&id=6d64b50d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d64b50d",
  null
  
)

export default component.exports